module.exports = __webpack_public_path__ + "static/media/codesandbox.ea6a886d.svg";